import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { DemandOverview } from '../models/demand-overview';

export class DemandOverviewApi {
    constructor(protected baseUrl: string) {}

    public cget = (
        customerAccountId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<DemandOverview>>> => {
        const params = new URLSearchParams(searchParams);
        params?.set('customerAccountId', customerAccountId.toString());
        return safeRequest(
            () => request.get(`${this.baseUrl}/demands`, { params }),
            response => response.data
        );
    };

    public decline(id: number, demandAccountId?: number, reason?: string): Promise<ApiResult<void>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/demands/${id}/submit`, {
                    id,
                    demandAccountId,
                    items: [],
                    noteFromCustomer: '',
                    declineReason: reason,
                }),
            noop
        );
    }
}
